import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';
import i18n from '../../../../lang';

export class ATLunchBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: () => BenefitAttribute[] = () => [
    {
      id: 'atLunchDailyLimit',
      accessorFn: value => value.atLunchOptions?.dailyLimit,
      header: 'AT_LUNCH.fields.dailyLimit',
      size: 100,
      renderer: value => (typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null),
    },
    {
      id: 'lunchDailyLimit',
      accessorFn: value =>
        value.atLunchOptions?.place ? i18n.t(`benefitsModule:AT_LUNCH.days.table.place.${value.atLunchOptions?.place}`) : '',
      header: 'AT_LUNCH.fields.place.title',
    },
  ];
}
